/**
 * Handles the form navigation path.
 * Transforms `/{form-name}-form` to `/consults/{form-name}-form`.
 * NOTE: no changes here ['medical-cannabis-form' to 'alternative-therapy-form']
 * since we reuse the current path structure.
 *
 * @param {object} params
 * @param {string} params.pathname
 * @returns {string | null}
 */
export const getFormNavigationPath = ({ pathname }) => {
  const splitPathname = pathname.split('/');

  if (splitPathname.length !== 2) {
    return null;
  }

  const formNameSplit = splitPathname[1].split('-form');
  const formName = formNameSplit[0];

  if (formName && formNameSplit.length === 2) {
    return `/consults/${formName}-form`;
  }

  return null;
};
